(function() {
  'use strict';

  if (typeof window.MADAKE_SET_CONFIG === 'undefined') return;
  if (window._madakeSetBundleLoaded) return;
  window._madakeSetBundleLoaded = true;

  const config    = window.MADAKE_SET_CONFIG;
  const slotCount = config.slotCount || 0;
  window.madakeSetState        = window.madakeSetState || {};
  window._madakeIsAddingToCart = false;

  // ─────────────────────────────────────────────────────────
  // FLOATING PREVIEW
  // ─────────────────────────────────────────────────────────
  let _floatingPreview = null;

  function getFloatingPreview() {
    if (!_floatingPreview) {
      _floatingPreview = document.createElement('div');
      _floatingPreview.id = 'madake-floating-preview';
      _floatingPreview.className = 'madake-set-swatch__preview';
      Object.assign(_floatingPreview.style, {
        display:       'none',
        position:      'fixed',
        zIndex:        '99999',
        pointerEvents: 'none',
      });
      document.body.appendChild(_floatingPreview);
    }
    return _floatingPreview;
  }

  function showFloatingPreview(sw) {
    const template = sw.querySelector('.madake-set-swatch__preview');
    if (!template) return;
    const fp = getFloatingPreview();
    fp.innerHTML = template.innerHTML;
    fp.style.display = 'block';
    const rect     = sw.getBoundingClientRect();
    const margin   = 10;
    const previewW = fp.offsetWidth  || 220;
    const previewH = fp.offsetHeight || 300;
    let left = rect.left + rect.width / 2 - previewW / 2;
    left = Math.max(margin, Math.min(left, window.innerWidth - previewW - margin));
    let top = rect.top - previewH - 12;
    if (top < margin) top = rect.bottom + 12;
    if (top + previewH > window.innerHeight - margin) {
      top = Math.max(margin, window.innerHeight - previewH - margin);
    }
    fp.style.left = left + 'px';
    fp.style.top  = top  + 'px';
    sw._fpActive = true;
  }

  function hideFloatingPreview(sw) {
    sw._fpActive = false;
    const anyActive = document.querySelector('.madake-set-swatch._fpActive');
    if (!anyActive) {
      const fp = getFloatingPreview();
      if (fp) fp.style.display = 'none';
    }
  }

  // ─────────────────────────────────────────────────────────
  // SWATCH CLICKS
  // ─────────────────────────────────────────────────────────
  function bindSwatchClicks() {
    document.querySelectorAll('.madake-set-slot').forEach(slotEl => {
      const slotNum        = parseInt(slotEl.dataset.slot, 10);
      const swatches       = slotEl.querySelectorAll('.madake-set-swatch');
      const personalizeBtn = slotEl.querySelector('[data-madake-open]');

      swatches.forEach(sw => {
        sw.addEventListener('click', e => {
          e.preventDefault();

          slotEl.querySelectorAll('.madake-set-swatch._fpActive').forEach(s => {
            clearTimeout(s._previewTimer);
            s._previewTimer = null;
            hideFloatingPreview(s);
          });

          showFloatingPreview(sw);
          clearTimeout(sw._previewTimer);
          sw._previewTimer = setTimeout(() => {
            hideFloatingPreview(sw);
            sw._previewTimer = null;
          }, 3000);

          swatches.forEach(s => s.classList.remove('is-selected'));
          sw.classList.add('is-selected');
          slotEl.classList.add('has-selection');

          slotEl.querySelector('[data-madake-button-wrap]')?.removeAttribute('hidden');

          if (personalizeBtn) {
            personalizeBtn.dataset.towelProductId   = sw.dataset.towelId;
            personalizeBtn.dataset.madakeSetContext = 'true';
          }

          window.madakeSetState[slotNum] = {
            ...(window.madakeSetState[slotNum] || {}),
            towelProductId: sw.dataset.towelId,
            towelVariantId: sw.dataset.towelVariantId || '',
            isPremium:      sw.dataset.isPremium === 'true',
            towelTitle:     sw.dataset.towelName || '',
          };
        });
      });
    });
  }

  // ─────────────────────────────────────────────────────────
  // DESKTOP HOVER PREVIEWS
  // ─────────────────────────────────────────────────────────
  function bindHoverPreviews() {
    document.querySelectorAll('.madake-set-swatch').forEach(sw => {
      let leaveTimer = null;
      sw.addEventListener('mouseenter', () => {
        clearTimeout(leaveTimer);
        showFloatingPreview(sw);
      });
      sw.addEventListener('mouseleave', () => {
        leaveTimer = setTimeout(() => {
          if (!sw._previewTimer) hideFloatingPreview(sw);
        }, 200);
      });
    });
  }

  // ─────────────────────────────────────────────────────────
  // PER-SLOT SAVE
  // ─────────────────────────────────────────────────────────
  document.addEventListener('madake:set-slot-saved', e => {
    const { slot, fullState } = e.detail || {};
    if (!slot) return;
    window.madakeSetState[slot] = { ...(window.madakeSetState[slot] || {}), fullState };
    document.querySelector(`.madake-set-slot[data-slot="${slot}"]`)?.classList.add('is-personalized');
  });

  // ─────────────────────────────────────────────────────────
  // ATC FINDER
  // ─────────────────────────────────────────────────────────
  function findATCButton() {
    return document.querySelector(
      'product-form button[name="add"], product-form button[type="submit"], ' +
      'form[action^="/cart/add"] button[type="submit"], ' +
      'form[action^="/cart/add"] button[name="add"]'
    );
  }

  // ─────────────────────────────────────────────────────────
  // BUILD ITEM LIST
  //
  // ← CHANGED: Returns a flat array of individual items instead
  // of batched groups. Each item is sent as its own /cart/add.js
  // request in doSetCartAdd, which is the only guaranteed way to
  // prevent Shopify from merging same-variant line items.
  //
  // Shopify merges items that share the same variant ID within a
  // single /cart/add.js request (sums quantities, ignores properties).
  // Cross-request merging also occurs when ALL visible (non-underscore)
  // properties are identical. Sending items individually and giving
  // each a unique visible property (Towel #N) prevents both.
  // ─────────────────────────────────────────────────────────
  function buildLinkedItems(sessionToken) {
    // Parent item — built separately and sent first
    const setProps = {
      '_hidden_type': 'madake_set_parent',
      '_session':     sessionToken,
    };
    for (let i = 1; i <= slotCount; i++) {
      const s = window.madakeSetState[i];
      if (!s) continue;
      setProps['Thin towel ' + i] = s.towelTitle || '';
      if (s.fullState?.name) {
        setProps['Personalization ' + i] = 'Yes';
        setProps['Name ' + i]            = s.fullState.name;
        setProps['Font ' + i]            = s.fullState.fontName  || '';
        setProps['Font Color ' + i]      = s.fullState.colorName || '';
        if (s.fullState.emojis?.length) {
          setProps['Emoji ' + i] = s.fullState.emojis.map(em => em.name || '').join(', ');
        }
      }
    }

    // Flat list of linked items — one entry per cart/add.js call  ← CHANGED
    const linkedItems = [];

    for (let j = 1; j <= slotCount; j++) {
      const s = window.madakeSetState[j];
      if (!s) continue;

      const towelShort = (s.towelTitle || '')
        .replace(/Personalized Thin bamboo bath towel-\s*/i, '')
        .replace(/Personalized Thin Bamboo Bath Towel-\s*/i, '')
        .trim();
      const forCtx     = towelShort + ' in ' + (config.setTitle || 'the set');
      const towelLabel = 'Towel #' + j;

      if (s.isPremium && config.premiumUpchargeVariantId) {
        linkedItems.push({
          id:       parseInt(config.premiumUpchargeVariantId, 10),
          quantity: 1,
          properties: {
            '_linked_to':   sessionToken,
            '_slot':        String(j),
            '_hidden_type': 'set_premium_selection',
            'Towel':        towelLabel,   // ← visible dedup key: always unique per slot
            'For':          forCtx,
          },
        });
      }

      if (s.fullState?.name) {
        linkedItems.push({
          id:       parseInt(config.embroideryVariantId, 10),
          quantity: 1,
          properties: {
            '_linked_to':   sessionToken,
            '_slot':        String(j),
            '_hidden_type': 'set_embroidery',
            'Towel':        towelLabel,   // ← visible dedup key
            'For':          forCtx,
            'Name':         s.fullState.name,
            'Font':         s.fullState.fontName  || '',
            'Thread Color': s.fullState.colorName || '',
          },
        });

        (s.fullState.emojis || []).forEach(emoji => {
          if (!emoji.variantId) return;
          linkedItems.push({
            id:       parseInt(emoji.variantId, 10),
            quantity: 1,
            properties: {
              '_linked_to':   sessionToken,
              '_slot':        String(j),
              '_hidden_type': 'set_emoji',
              'Towel':        towelLabel,  // ← visible dedup key
              'For':          forCtx,
              'Emoji':        emoji.name     || '',
              'Position':     emoji.position || '',
            },
          });
        });
      }
    }

    return { parentItem: { id: config.setVariantId, quantity: 1, properties: setProps }, linkedItems };
  }

  // ─────────────────────────────────────────────────────────
  // CART ADD
  //
  // ← CHANGED: Sends each linked item as its own /cart/add.js
  // call (one item per request). This is the only reliable way
  // to guarantee Shopify creates a separate line item for each
  // add-on, regardless of variant ID collisions.
  //
  // Why not batch? Shopify merges items sharing a variant ID
  // within a single request by summing quantities and discarding
  // properties. Even across requests, if all visible properties
  // are identical, Shopify merges. One-item-per-request + unique
  // Towel #N label = guaranteed separate line items.
  // ─────────────────────────────────────────────────────────
  async function doSetCartAdd() {
    if (window._madakeIsAddingToCart) {
      console.log('[Madake Set] blocked — already adding');
      return;
    }
    window._madakeIsAddingToCart = true;
    console.log('[Madake Set] doSetCartAdd started');

    for (let i = 1; i <= slotCount; i++) {
      if (!window.madakeSetState[i]?.towelProductId) {
        alert('Please select a towel for slot ' + i + '.');
        window._madakeIsAddingToCart = false;
        return;
      }
    }

    const sessionToken = 'ms_' + Date.now() + '_' + Math.random().toString(36).slice(2, 7);
    const { parentItem, linkedItems } = buildLinkedItems(sessionToken);  // ← CHANGED

    const atcBtn = findATCButton();
    let textEl;
    if (atcBtn) {
      atcBtn.disabled = true;
      atcBtn.setAttribute('aria-busy', 'true');
      textEl = atcBtn.querySelector('.add-to-cart-text__content') || atcBtn;
      textEl._originalText = textEl.textContent;
      textEl.textContent = 'Adding…';
    }

    try {
      // Step 1: Add parent set as its own request
      const pr = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ items: [parentItem] }),
      });
      if (!pr.ok) throw new Error('Parent add failed: ' + await pr.text());

      // Step 2: Add each linked item individually — one request per item.  ← CHANGED
      // This is the key fix: guarantees Shopify never merges two add-ons
      // that share a variant ID, regardless of their properties.
      for (const item of linkedItems) {
        const r = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ items: [item] }),
        });
        if (!r.ok) {
          console.error('[Madake Set] linked item add failed:', await r.text(), item);
          throw new Error('Linked item add failed for slot ' + item.properties['_slot']);
        }
      }

      window.location.href = '/cart';

    } catch (err) {
      console.error('[Madake Set] ATC error:', err);
      alert('Failed to add to cart. Please try again.');
      window._madakeIsAddingToCart = false;
      if (atcBtn) {
        atcBtn.disabled = false;
        atcBtn.removeAttribute('aria-busy');
        if (textEl?._originalText) textEl.textContent = textEl._originalText;
      }
    }
  }

  // ─────────────────────────────────────────────────────────
  // INTERCEPT ATC
  // ─────────────────────────────────────────────────────────
  function interceptATC() {
    const atcBtn = findATCButton();
    if (!atcBtn) { console.warn('[Madake Set] ATC button not found'); return; }

    const clone = atcBtn.cloneNode(true);
    atcBtn.parentNode.replaceChild(clone, atcBtn);

    const handle = e => { e.preventDefault(); e.stopImmediatePropagation(); doSetCartAdd(); };
    clone.addEventListener('click', handle);
    const form = clone.closest('form[action*="/cart/add"]');
    if (form) form.addEventListener('submit', handle, true);
  }

  // ─────────────────────────────────────────────────────────
  // INIT
  // ─────────────────────────────────────────────────────────
  function init() {
    bindSwatchClicks();
    bindHoverPreviews();
    interceptATC();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
